import { mergeIconColorVars as e } from "../icon-props.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/icons/arrow-down.tsx
function n({ colors: n, style: r, ...i }) {
	return /* @__PURE__ */ t("svg", {
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		focusable: "false",
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			...e(n),
			...r
		},
		...i,
		children: /* @__PURE__ */ t("path", {
			d: "M11 5C11 4.44772 11.4478 4 12 4C12.5523 4 13 4.44772 13 5V16.5859L18.293 11.293C18.6835 10.9024 19.3166 10.9024 19.7071 11.293C20.0976 11.6835 20.0976 12.3165 19.7071 12.707L12.7071 19.707C12.3166 20.0976 11.6835 20.0976 11.293 19.707L4.29302 12.707C3.90249 12.3165 3.90249 11.6835 4.29302 11.293C4.65913 10.9269 5.23813 10.9043 5.63091 11.2246L5.70708 11.293L11 16.5859V5Z",
			fill: "var(--icon-color-primary, currentColor)"
		})
	});
}
//#endregion
export { n as ArrowDownIcon };
